import { UseQueryResult, useQuery } from "react-query";

import { createVersionedClient } from "services/ocClient";
import { Tenant } from "types/entities";

export const useTenant = (id: number, version_number: number): UseQueryResult<Tenant, Error> => {
  const client = createVersionedClient(version_number);
  return useQuery<Tenant, Error>({
    queryKey: ["tenants", id, version_number],
    queryFn: async (): Promise<Tenant> => {
      const response = await client.get<Tenant>(`/api/tenants/${id}`);
      return response.data;
    },
    keepPreviousData: true,
  });
};
